/*
 *
 * AddShelf
 *
 */

import React from 'react';
import Img from 'components/Img';
import styled from 'styled-components/macro';
import { css } from 'styled-components';
import { FiChevronDown } from 'react-icons/all';

interface Props {
  small: boolean;
  img: any;
  onClick: any;
  title: string;
  showImg?: boolean;
  className?: string;
  disable?: boolean;
  tooltip?: string | null;
}

function Button({
  onClick,
  img,
  small,
  title,
  showImg = true,
  className,
  disable = false,
  tooltip,
}: Props) {
  return (
    <StyledButton
      small={small}
      onClick={() => {
        !disable && onClick();
      }}
      className={className}
      disable={disable}
      data-tip={tooltip}
      data-for="composition"
    >
      {showImg && (
        <StyledImgContainer short={small}>
          <Img src={img} alt={title} className={small ? 'h-8' : 'h-12'} />
        </StyledImgContainer>
      )}
      <StyledTitle short={small} disable={disable}>
        {title}
      </StyledTitle>
      {!showImg && !disable && <FiChevronDown className="h-4 w-4" />}
    </StyledButton>
  );
}

export default Button;

const StyledButton = styled.button<{ small: boolean; disable: boolean }>`
  display: flex;
  flex-direction: ${props => (props.small ? 'row' : 'column')};
  align-items: center;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  height: 100%;

  ${p =>
    p.disable &&
    css`
      cursor: not-allowed;
    `}
`;

const StyledImgContainer = styled.div<{ short: boolean }>`
  //margin-top: ${props => (props.short ? '0.5rem' : '0')};
`;

const StyledTitle = styled.div<{ short: boolean; disable: boolean }>`
  font-weight: 400;
  margin-top: 0.25rem;
  color: ${props => props.theme.gray800};
  font-size: 0.95rem;

  ${p =>
    p.disable &&
    css`
      color: ${p => p.theme.gray600};
    `}

  @media (min-width: 1024px) {
    line-height: 1;
  }

  @media (min-width: 1280px) {
    line-height: 1.25;
  }

  ${p =>
    p.short &&
    css`
      margin-left: 0.5rem;
    `}
`;
